export default __webpack_public_path__ + "static/media/cartLW.3a55b3c6.svg";